import { useMemo } from "react";

const OVERRIDE = null;

export function useLocale() {
  const defaultLocale = useMemo(() => {
    return Intl.NumberFormat().resolvedOptions().locale;
  }, []);

  return OVERRIDE ?? defaultLocale;
}
